<template>
  <div class="owrap">
    <div v-if="!hasData">
      <NoData msg="亲,您还没有订单信息哦!"/>
    </div>
    <div v-if="hasData">
      <div v-for="(item,index) in list" :key="index">
        <ListOrder :list="item" @Jump="Jump">
          <div slot="footerBtn" v-if="item.state==0">
            <button class="ListBtn ListBtnCancel" @click="cencel(item.id,'是否取消订单')">取消</button>
            <button class="ListBtn ListBtnPay" @click="buy(item.id)">付款</button>
          </div>
          <div slot="footerBtn" v-if="item.state==1">
            <button class="ListBtn ListBtnCancel" @click="cencel(item.id,'是否申请取消订单')">申请取消</button>
          </div>
          <div slot="footerBtn" v-if="item.state==2">
            <button class="ListBtn" @click="finish(item.id)">确认收货</button>
          </div>
          <div slot="footerBtn" v-if="item.state==3">
            <button class="ListBtn" @click="appraise(item.id)">评价</button>
          </div>
        </ListOrder>
      </div>
    </div>
  </div>
</template>

<script>
import ListOrder from "@/components/ListOrder.vue";
import NoData from "@/components/NoData.vue";
import {
  GetOrderLists,
  cencelOrder,
  OrderBuy,
  finishOrder
} from "../../apis/https.js";
import { Dialog } from "vant";
import { getSessionStorage, getLocalStorage } from "../../utils/storage.js";
// import { Checkbox, CheckboxGroup } from "vant";
// import Vue from "vue";
// Vue.use(Checkbox).use(CheckboxGroup);
export default {
  components: {
    ListOrder,
    NoData
  },
  props: ["index"],
  data() {
    return {
      hasData: false,
      token: "",
      list: [],
      active: 0
    };
  },
  created() {},
  // computed: {
  //   isChange() {
  //     return this.index;
  //   }
  // },
  // watch: {
  //   isChange() {}
  // },
  created() {
    this.token = getLocalStorage("login_token");
    let txt = "";
    switch (this.index) {
      case "0":
        txt = "all";
        break;
      case "1":
        txt = "payment";
        break;
      case "2":
        txt = "delivery";
        break;
      // case "3":
      //   txt = "received";
      //   break;
      case "4":
        txt = "comment";
        break;
    }
    if (txt != "" && this.index == "2") {
      this.GetOrderLists(1, "delivery", this.token);
      this.GetOrderLists(1, "received", this.token);
    } else if (txt != "" && this.index != "2") {
      this.GetOrderLists(1, txt, this.token);
    }
  },
  activated() {
  },
  methods: {
    GetOrderLists(page, dataType, token) {
      GetOrderLists(page, dataType, token)
        .then(res => {
          let data = res.data.list.data;

          if (data.length > 0) {
            this.hasData = true;
            for (let i in data) {
              let state = -1;
              if (data[i].pay_time === 0 && data[i].state_text != "已取消") {
                //待付款
                state = 0;
              } else if (
                data[i].pay_time > 0 &&
                data[i].delivery_time == 0 &&
                data[i].state_text != "已取消"
              ) {
                //待发货
                state = 1;
              } else if (
                data[i].delivery_time > 0 &&
                data[i].receipt_time == 0 &&
                data[i].state_text != "已取消"
              ) {
                //待收货
                state = 2;
              } else if (
                data[i].receipt_time > 0 &&
                data[i].state_text != "已取消"
              ) {
                //完成
                state = 3;
              }
              if (data[i].goods.length > 0) {
                let img = [];
                let total_num = 0;
                for (let j in data[i].goods) {
                  if (img.length < 3) {
                    img.push(data[i].goods[j].image.file_path);
                  }
                  total_num =
                    total_num + parseFloat(data[i].goods[j].total_num);
                }
                this.list.push({
                  id: data[i].order_id,
                  state_text: data[i].state_text,
                  total_price: data[i].total_price,
                  order_no: data[i].order_no,
                  create_time: data[i].create_time,
                  img: img,
                  total_num: total_num,
                  state: state
                });
              }
            }
          }
        })
        .catch(e => {});
    },
    Jump(id) {
      this.$router.push({
        name: "odetail",
        query: {
          id: id,
          active: this.index
        }
      });
    },
    cencel(id, msg) {
      Dialog.confirm({
        title: "提示",
        message: msg
      })
        .then(() => {
          // on confirm
          this.$toast.loading({
            duration: 0, // 持续展示 toast
            forbidClick: true, // 禁用背景点击
            loadingType: "spinner",
            message: "加载中"
          });
          cencelOrder(id, getLocalStorage("login_token"))
            .then(res => {
              this.$toast.clear();
              Dialog.alert({
                title: "提示",
                message: msg
              }).then(() => {
                // on close
                this.$router.go(0);
              });
            })
            .catch(e => {});
        })
        .catch(() => {
          // on cancel
        });
    },
    buy(oid) {
      this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: "spinner",
        message: "加载中"
      });
      OrderBuy(oid, "url", getLocalStorage("login_token"))
        .then(res => {
          location.href = res.data.ali_pay_url;
        })
        .catch(e => {
          this.$toast.clear();
          this.$toast.fail("支付失败");
        });
    },
    finish(id) {
      Dialog.confirm({
        title: "提示",
        message: "是否确认收货?"
      })
        .then(() => {
          // on confirm
          this.$toast.loading({
            duration: 0, // 持续展示 toast
            forbidClick: true, // 禁用背景点击
            loadingType: "spinner",
            message: "加载中"
          });
          finishOrder(id, getLocalStorage("login_token")).then(res => {
            this.$toast.clear();
            Dialog.alert({
              title: "提示",
              message: "订单已完成"
            }).then(() => {
              // on close
              this.$router.go(0);
            });
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    appraise(id) {
      this.$router.push({
        name: "appraise",
        query: {
          id: id
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
@import url("../../style/skin.less");
.owrap {
  height: calc(100vh - 90px);
  overflow: auto;
}
.ListBtn {
  border-radius: 4px;
  border: 1px solid #ccc;
  padding: 3px 10px;
  font-size: 14px;
  color: #555;
  background: @white;
  vertical-align: top;
  float: left;
  margin-left: 10px;
}
.ListBtnPay {
  color: @text;
  border-color: @text;
}
</style>